<template>
  <div id="app" class="wrapper">
    <div class="navbar-minimize-fixed">
      <button class="minimize-sidebar btn btn-link btn-just-icon">
        <i
          class="tim-icons icon-align-center visible-on-sidebar-regular text-muted"
        ></i>
        <i
          class="tim-icons icon-bullet-list-67 visible-on-sidebar-mini text-muted"
        ></i>
      </button>
    </div>
    <app-side-bar v-if="!noSideBar"></app-side-bar>
    <div class="main-panel">
      <app-header v-if="!noHeader"></app-header>
      <div :class="'content ' + (noSideBar ? 'pl-30' : '')" id="content">
        <router-view />
        <iphone-frame-preview v-if="hasIphoneContainer"></iphone-frame-preview>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import SideBar from "@/components/SideBar";
export default {
  components: {
    appHeader: Header,
    appSideBar: SideBar,
  },
  computed: {
    noHeader() {
      return this.$route.name == "Signin";
    },
    hasIphoneContainer() {
      const page = this.$route.name
      return page == 'Graph' || page == 'Dashboard'
    },
    noSideBar(){
      const pages = ["Home", "Signin", "Create", "Edit"]
      return pages.indexOf(this.$route.name) >= 0
    }
  },
};

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

Array.prototype.last = function() {
  return this[this.length - 1];
};

String.prototype.abbr = function() {
  return this.split(" ")
    .map((item) => item[0])
    .join("")
    .toUpperCase();
};
</script>

<style>
html, body {
  line-height: unset;
}

.table-responsive {
  overflow: unset;
}
.sidebar .sidebar-wrapper {
  overflow: unset;
}

.pl-30 {
  padding-left: 30px !important;
}

.flex1 {
  flex: 1
}

#content {
  display: flex;
}

.bg-black {
  background-color: black;
}

.bold {
  font-weight: bold;
}

.cursor {
  cursor: pointer
}

.errorBox {
  color: red
}
</style>
